import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationComponent } from './core/authentication/authentication.component';
import { ChangePasswordComponent } from './core/change-password/change-password.component';

import { HttpClientModule } from '@angular/common/http';
import { HomePageComponent } from './components/home-page/home-page.component';
import { MaterialHelperModule } from './core/material-helper.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NavigationLayoutComponent } from './core/navigation-layout/navigation-layout.component';
import { TeamsComponent } from './components/teams/teams.component';
import { CreateTeamComponent } from './components/create-team/create-team.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';

// aws-amplify
import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { SpAssessmentsComponent } from './components/sp-assessments/sp-assessments.component';
// aws-amplify

import { CoreServicesService } from './core/services/core-services.service';
import { SharedModule } from './modules/shared/shared.module';
import { ShareFinalTreeDialogComponent } from './modules/workshop/share-the-tree/share-the-tree.component';
import { JoyrideModule } from 'ngx-joyride';
import { KanbanModule } from '@syncfusion/ej2-angular-kanban';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserEditPopupComponent } from './components/create-team/user-edit-popup/user-edit-popup.component';

@NgModule({
    declarations: [
        AppComponent,
        AuthenticationComponent,
        ChangePasswordComponent,
        HomePageComponent,
        NavigationLayoutComponent,
        TeamsComponent,
        CreateTeamComponent,
        SpAssessmentsComponent,
        ShareFinalTreeDialogComponent,
        UserEditPopupComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MaterialHelperModule,
        SharedModule,
        FlexLayoutModule,
        NgxSpinnerModule,
        DragDropModule,
        ScrollingModule,
        AppRoutingModule,
        AmplifyAngularModule,
        KanbanModule,
        JoyrideModule.forRoot()
    ],
    providers: [AmplifyService, CoreServicesService],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
